export default "__VITE_ASSET__83d8f722__"